import React from "react";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_toad-factory/artifacts/0sl21so2_1778465183515.png";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="relative bg-[#0A0A0A] border-t border-[#2A2A2A]">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 pt-16 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 pb-12 border-b border-[#2A2A2A]">
          <div className="md:col-span-5">
            <span className="logo-tile p-3 mb-5">
              <img src={LOGO_URL} alt="Forge State 3D Manufacturing" className="h-24 w-auto" />
            </span>
            <p className="font-body text-white/60 max-w-xs text-sm">
              Industrial-grade additive manufacturing. Run by humans. Quoted by humans.
              Based in Akron, OH.
            </p>
          </div>
          <div className="md:col-span-2">
            <p className="font-mono-ui text-[10px] tracking-[0.3em] text-white/40 uppercase mb-4">SITE</p>
            <ul className="space-y-2 font-mono-ui text-sm">
              {[["Work", "#work"], ["Services", "#services"], ["Process", "#process"], ["Quote", "#quote"], ["Contact", "#contact"]].map(
                ([l, h]) => (
                  <li key={h}><a href={h} className="text-white/70 hover:text-[#FF5722]">{l}</a></li>
                ),
              )}
            </ul>
          </div>
          <div className="md:col-span-2">
            <p className="font-mono-ui text-[10px] tracking-[0.3em] text-white/40 uppercase mb-4">SOCIAL</p>
            <ul className="space-y-2 font-mono-ui text-sm">
              <li><a className="text-white/70 hover:text-[#FF5722]" href="#">Instagram</a></li>
              <li><a className="text-white/70 hover:text-[#FF5722]" href="#">Are.na</a></li>
              <li><a className="text-white/70 hover:text-[#FF5722]" href="#">GitHub</a></li>
            </ul>
          </div>
          <div className="md:col-span-3">
            <p className="font-mono-ui text-[10px] tracking-[0.3em] text-white/40 uppercase mb-4">WORKSHOP</p>
            <p className="font-mono-ui text-sm text-white/70 leading-relaxed">
              Based in Akron, OH<br />
              MON–FRI · 09:00–18:00
            </p>
          </div>
        </div>

        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-white/40 font-mono-ui text-[10px] tracking-[0.25em] uppercase pt-8">
          <p>© {new Date().getFullYear()} Forge State 3D Manufacturing LLC. All rights reserved.</p>
          <p>BUILT IN AKRON · ISO 9001 PROCESSES · v1.0</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
